import React from "react";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import { useSearchParams } from "react-router-dom";

import {
  HubButton,
  HubContextMenu,
  HubHookFormDatePicker,
  HubHookFormWrapper,
} from "../../components";

export const HubFilterTimeMenu = ({
  startDate = "",
  endDate = "",
  label = "Start Date",
  id = "startDate",
  buttonProps = {},
  icon,
}) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const idValue = searchParams.get(id);
  const values = idValue?.split("-")?.length
    ? idValue?.split("-")
    : [startDate, endDate];
  const defaultStartDate = values[0];
  const defaultEndDate = values[1];

  const setSearchHelper = (newValue) =>
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newValue ? newParams.set(id, newValue) : newParams.delete(id);
      return newParams;
    });

  const handleChange = (date, index = 0) => {
    const origin = dayjs(date);
    const final = origin.startOf("day");
    const formatted = final.format("MM/DD/YYYY");
    const valuesCopy = [...values];
    valuesCopy[index] = formatted;
    const filtered = valuesCopy?.filter(Boolean);

    const query = filtered?.length > 1 ? filtered.join("-") : filtered[0];
    setSearchHelper(query);
  };

  const Menu = (
    <HubHookFormWrapper onSubmit={() => {}}>
      <Stack gap="15px" padding="15px" maxWidth="550px">
        <Typography variant="boldCaption" color="hubColors.mainFocus">
          Filter by {label}
        </Typography>

        <Stack direction="row" gap="5px">
          <HubHookFormDatePicker
            name="startDate"
            label="Start Date"
            onAccept={handleChange}
            defaultValue={defaultStartDate}
            showDaysOutsideCurrentMonth
          />
          <HubHookFormDatePicker
            name="endDate"
            label="End Date"
            onAccept={(date) => handleChange(date, 1)}
            defaultValue={defaultEndDate}
            showDaysOutsideCurrentMonth
          />
        </Stack>

        <HubButton
          label="Reset Filter"
          variant="text"
          size="small"
          sx={{ padding: "0px 5px" }}
          onClick={() => setSearchHelper()}
        />
      </Stack>
    </HubHookFormWrapper>
  );

  const filterString =
    defaultStartDate || defaultEndDate
      ? values.length > 1
        ? values.join("-")
        : `${values[0]} >=`
      : "";

  const MenuButton = (
    <HubButton
      variant="tinyButton"
      label={`${label} ${filterString}`}
      color="neutral"
      sx={{ backgroundColor: "hubColors.white" }}
      {...(icon && { icon })}
      iconProps={{ size: 10 }}
      {...buttonProps}
    />
  );

  return (
    <HubContextMenu
      id={`filter-${id}`}
      menuButton={MenuButton}
      IconButtonProps={{ sx: { padding: 0, minHeight: 0 } }}
    >
      {Menu}
    </HubContextMenu>
  );
};

export default HubFilterTimeMenu;
